import React from "react";
import { Box } from "@mui/material";
import documentSettingsTokens from "../DocumentSettings.tokens";

interface SelectChevronIconProps {
  /** Forwarded by MUI when used as `Select`'s `IconComponent`. */
  className?: string;
}

/**
 * Inline chevron traced from the Document Settings design. Size and position
 * come from the `.MuiSelect-icon` rule in `DocumentSettings.styles.ts`; the
 * stroke colour and width come from `DocumentSettings.tokens.ts`.
 */
export const SelectChevronIcon: React.FC<SelectChevronIconProps> = ({
  className,
}) => (
  <Box
    component="svg"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke={documentSettingsTokens.select.iconColor}
    strokeWidth={documentSettingsTokens.select.iconStrokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 9l6 6 6-6" />
  </Box>
);

export default SelectChevronIcon;
